import type { EventPart } from '@hopin-team/api-hopin';

export interface LinkProps {
  as: string;
  href: string;
  isExternal?: boolean;
  isNewTab?: boolean;
}

export interface getLinkPropsArgs {
  event_part_type: EventPart;
  eventSlug: string;
  stageUuid?: string;
  sessionUuids?: string[];
  vendorId?: number;
  external_url?: string | null;
  external_url_new_tab?: boolean;
  customSegment?: { title: string; url: string; new_window: boolean } | null;
  external_id?: string;
}

export const getLinkProps = ({
  event_part_type,
  eventSlug,
  stageUuid,
  sessionUuids,
  vendorId,
  external_url,
  external_url_new_tab,
  customSegment,
  external_id,
}: getLinkPropsArgs): LinkProps | null => {
  if (event_part_type === 'break') {
    return null;
  }

  const isExternalUrl = event_part_type === 'external_url';
  const isCustom = event_part_type === 'custom';
  const externalUrl = isCustom ? customSegment?.url : external_url;
  const isNewTab = isCustom ? customSegment?.new_window : external_url_new_tab;

  if (isExternalUrl || isCustom) {
    return {
      as: externalUrl || '',
      href: externalUrl || '',
      isExternal: true,
      isNewTab: isNewTab,
    };
  }

  const hrefPrefix = '/events/[eventSlug]';
  const asPrefix = `/events/${eventSlug}`;

  if (event_part_type === 'stage') {
    return {
      href: `${hrefPrefix}/stages${stageUuid ? '/[stageUuid]' : ''}`,
      as: `${asPrefix}/stages/${stageUuid || ''}`,
    };
  }
  if (event_part_type === 'sessions') {
    if (sessionUuids && sessionUuids.length > 1) {
      return {
        href: `${hrefPrefix}/sessions${
          external_id ? `?scheduleItem=${external_id}` : ''
        }`,
        as: `${asPrefix}/sessions${
          external_id ? `?scheduleItem=${external_id}` : ''
        }`,
      };
    }

    const sessionSpecified = sessionUuids?.length === 1;
    return {
      href: `${hrefPrefix}/sessions${sessionSpecified ? '/[sessionId]' : ''}`,
      as: `${asPrefix}/sessions${
        sessionSpecified ? `/${sessionUuids[0]}` : ''
      }`,
    };
  }
  if (event_part_type === 'expo') {
    return {
      href: `${hrefPrefix}/expo${vendorId ? '/[vendorId]' : ''}`,
      as: `${asPrefix}/expo${vendorId ? `/${vendorId.toString()}` : ''}`,
    };
  }
  if (event_part_type === 'app') {
    return {
      href: `${hrefPrefix}/${event_part_type}`,
      as: `${asPrefix}/${event_part_type}`,
    };
  }
  return {
    href: `${hrefPrefix}/${event_part_type}`,
    as: `${asPrefix}/${event_part_type}`,
  };
};
